function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_2589",
  "data-name": "Groupe 2589"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_7952",
  "data-name": "Trac\\xE9 7952",
  d: "M963.91,806.65a66.55,66.55,0,0,0,36.08-59,65.25,65.25,0,0,0-36-59.45l-9.29-4.72V420.78L957,417a37,37,0,0,0,4.54-12.89A22.49,22.49,0,0,0,948,384.48L525.9,195.37a114.49,114.49,0,0,0-91.44,0L12.67,384.26A19.41,19.41,0,0,0,0,403.74a22.7,22.7,0,0,0,15,20.34l161.35,54.69v209a21.7,21.7,0,0,0,8.84,17.94A23.71,23.71,0,0,0,205.79,708a777.31,777.31,0,0,1,548.48-.45l10.38,1.72a20.21,20.21,0,0,0,10.53-3.74,22.78,22.78,0,0,0,9.74-18.17V478.81l126.7-43.27V683.36l-9.18,4.75a66.77,66.77,0,0,0,61.47,118.54ZM742.06,657.51l-21.91-6.71a816.24,816.24,0,0,0-478.74,0l-21.91,6.71V476.45l11.57-3.74a789.6,789.6,0,0,1,499.45,0l11.58,3.74Zm23.49-217.62-5.51-2a825.08,825.08,0,0,0-559.69,0l-5.54,2L80.14,401.64,452.36,234.52a70.63,70.63,0,0,1,55.49,0l374,167.34Zm143,310.26v-2.47a24.91,24.91,0,0,1,24.87-24.88h2.4a25,25,0,0,1,21.35,24.84,23.74,23.74,0,0,1-23.64,23.6h-.37a25,25,0,0,1-24.58-21.09Z"
}));

function SvgTeach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeach);
export default __webpack_public_path__ + "static/media/teach.97e3c211.svg";
export { ForwardRef as ReactComponent };